<template>
    <div v-if="user">
        <template v-if="fetchingContributions && loading">
            <div class="content-loader">
                <ContentLoader
                    :height="320"
                    :width="1076"
                    :speed="2"
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                    class="mb-2"
                >
                    <rect x="16" y="0" rx="0" ry="0" width="1060" height="100"/>
                    <rect x="16" y="120" rx="0" ry="0" width="1060" height="80"/>
                    <rect x="16" y="220" rx="0" ry="0" width="1060" height="100"/>
                </ContentLoader>
            </div>
        </template>
        <template v-else>
            <div class="supporter-contributions card columns is-multiline pt-5 pb-6 mb-3" v-if="!contributions.total">
                <div class="column is-1 mx-auto text-center mb-1">
                    <img class="icon__email-sent" src="/img/icons/contribute.svg" alt="Email icon"/>
                </div>
                <div class="column is-full mb-1">
                    <h1 class="w-872 mx-auto text-center">Member Contributions</h1>
                </div>
                <div class="column is-full">
                    <p class="w-648 t-black mx-auto text-center mb-2">If you are aware of more technical details
                        about
                        {{ contributionModel.name }}, please get involved and contribute to the database, so individuals
                        worldwide
                        can
                        utilise the experience of others to prevent further injury and death. </p>
                </div>
                <div class="column is-2 mx-auto">
                    <cat-uxo-contribute
                        :contribution-model="contributionModel"
                        :contribution-type="contributionType"
                        :user="user" :button="'Contribute'"></cat-uxo-contribute>
                </div>
            </div>
            <div v-else class="supporter-contributions card p-2 p-sm-4 mb-10">
                <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-5">
                    <h2 class="t-orange mb-3 mb-md-0">Member Contributions</h2>
                    <cat-uxo-contribute
                        :contribution-type="contributionType"
                        :contribution-model="contributionModel"
                        :user="user" :button="'Contribute'"></cat-uxo-contribute>
                </div>
                <div class="d-flex mb-4" v-for="contribution in contributions.data">
                    <div class="avatar mr-2"><span class="avatar__initials">{{ contribution.initials }}</span></div>
                    <div class="contribution">
                        <div class="contribution__meta fs-12 font-weight-light t-navy lh-sm mb-1">
                            {{ contribution.name }} added a contribution on {{ formattedDate(contribution.created_at) }}
                        </div>
                        <div class="contribution__content font-weight-light lh-lg mb-2">
                            <p class="paragraph">{{ contribution.contribution_text }}</p>
                            <div v-if="getLinks(contribution.contribution_text)" class="social-card-wrapper">
                                <div class="social-card-container"
                                     :key="index"
                                     v-for="(link, index) in getLinks(contribution.contribution_text)">
                                    <link-prevue :apiUrl="$root.linkPrevueApiUrl" :url="link.href">
                                        <template slot-scope="props">
                                            <a v-if="props.img || props.title || props.description"
                                               target="_blank"
                                               v-bind:href="props.url">
                                                <div class="social-card">
                                                    <div v-if="props.img" class="social-card__image"
                                                         :style="`background-image: url('${props.img}')`">

                                                    </div>
                                                    <div class="social-card__content">
                                                        <h4 v-if="props.title" class="social-card__content-title">
                                                            {{ props.title }}</h4>
                                                        <p v-if="props.description" class="social-card__content-body">
                                                            {{ props.description }}</p>
                                                    </div>
                                                </div>
                                            </a>
                                            <div v-else></div>
                                        </template>
                                    </link-prevue>
                                </div>
                            </div>
                        </div>
                        <cat-uxo-thumbnail-gallery v-if="contribution.files.length"
                                                   :files="contribution.files"></cat-uxo-thumbnail-gallery>
                        <cat-uxo-file-list class="d-flex flex-column flex-md-row mt-1"
                                           v-if="contribution.files.length"
                                           :files="contribution.files" :listStyle="'pill'"></cat-uxo-file-list>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="contributions.last_page > 1">
            <paginate
                class="mt-3"
                :page-count="contributions.last_page"
                :prev-text="'&nbsp;'"
                :next-text="'&nbsp;'"
                :prev-link-class="'pagination-previous'"
                :next-link-class="'pagination-next'"
                :container-class="'pagination-list'"
                :page-class="'pagination-item'"
                :page-link-class="'pagination-link'"
                :click-handler="paginate">
            </paginate>
        </template>
    </div>
</template>

<script>
import {ContentLoader} from 'vue-content-loader';
import {mapActions, mapState} from "vuex";
import moment from "moment";
import CatUxoFileList from '@/js/components/shared/FileList';
import CatUxoThumbnailGallery from '@/js/components/shared/ThumbnailGallery';
import CatUxoContribute from '@/js/components/shared/Contribute';
import LinkPrevue from '@/js/components/shared/LinkPrevue'
import * as linkify from 'linkifyjs';
import contribution from "../store/modules/contribution";

export default {
    name: "CatUxoSupporterContributions",
    components: {
        ContentLoader,
        CatUxoThumbnailGallery,
        CatUxoFileList,
        CatUxoContribute,
        LinkPrevue
    },
    props: {
        user: {
            type: Object,
            required: false
        },
        contributionType: {
            type: Number,
            default: 2
        },
        contributionModel: {
            type: Object,
            required: true
        }
    },
    methods: {
        ...mapActions('contribution', [
            'fetchHazardContributions',
        ]),
        formattedDate(date) {
            return moment(date, 'YYYY-MM-DD HH:mm:ss').format('Do MMMM YYYY @ HH:mm');
        },
        paginate: function (page) {
            this.fetchHazardContributions({
                hazardId: this.contributableId,
                contributionType: this.contributionType,
                page: page
            })
        },
        getLinks(content) {
            return linkify.find(content).filter(link => {
                return link.type === 'url'
            })
        },
    },
    computed: {
        ...mapState('hazards', [
            'hazard',
        ]),
        ...mapState('terroristGroups', [
            'terroristGroup',
        ]),
        ...mapState('incidents', [
            'incident',
        ]),
        ...mapState('contribution', [
            'fetchingContributions',
            'contributions',
        ])
    },
    data() {
      return {
          loading: true,
          contributableId: undefined
      }
    },
    mounted() {

        this.$watch(vm => [vm.hazard, vm.terroristGroup, vm.incident], val => {
            const contribution = val.filter(v => Object.prototype.hasOwnProperty.call(v, 'id')).shift()
            this.contributableId = contribution.id
            this.loading = false
        }, {
            immediate: true, // run immediately
            deep: true // detects changes inside objects. not needed here, but maybe in other cases
        })

        this.$watch(vm => vm.loading, val => {
            if (!val) this.paginate(1)
        }, {
            immediate: true, // run immediately
            deep: true // detects changes inside objects. not needed here, but maybe in other cases
        })

    }
}
</script>
<style lang="scss" scoped>

.btn-contribute {
    max-width: rem(192px);
}

.contribution {
    max-width: 80%;

    @include media-breakpoint-up(sm) {
        max-width: 90%;
    }
}

.contribution {
    &__content {
        .paragraph {
            white-space: pre-line;
        }
    }
}

@include media-breakpoint-down(sm) {
    .contribution__files {
        .btn {
            max-width: rem(200px);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/SupporterContributions.vue